export const EVENT_NAME = {
  ADD_TO_BETSLIP: "Add To Betslip"
};
